import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface IProps {
  label: React.ReactNode;
  hint: React.ReactNode;
}

// The Tooltip needs a child that takes a ref, which the antd Space does not.
const InfoLabel = ({ label, hint }: IProps): JSX.Element => (
  <Tooltip title={hint}>
    <span>
      {label}
      <InfoCircleOutlined className="integration-monitoring__info-icon" />
    </span>
  </Tooltip>
);

export default InfoLabel;
